// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `input:-webkit-autofill,
input:-webkit-autofill:hover,
input:-webkit-autofill:focus,
input:-webkit-autofill:active {
  -webkit-box-shadow: 0 0 0px 1000px white inset;
  -webkit-transition: background-color 5000s ease-in-out 0s;
  transition: background-color 5000s ease-in-out 0s;
  -webkit-text-fill-color: #555 !important;
}

.btn-enviar {
  margin-top: 20px;
}

.navegacao .ponto {
  display: inline-block;
  width: 6px;
  height: 6px;
  border-radius: 100%;
  background-color: #cccccc;
  margin: 0 5px;
  cursor: pointer;
}
.navegacao .ponto.ativo {
  background-color: #22b7ff;
}

.btn-invertido {
  font-family: "Pague.la", "Open Sans", sans-serif;
  font-size: 1.8rem;
  padding: 10px 30px;
  border-radius: 5px;
  letter-spacing: 0.8px;
  font-weight: bolder;
  color: #999999;
}
.btn-invertido:active, .btn-invertido:hover, .btn-invertido:focus {
  box-shadow: none !important;
  text-decoration: underline;
}

.secoes {
  overflow: hidden;
}

.secao {
  position: relative;
}

.btns {
  position: relative;
  width: 100%;
  height: 100px;
}

.btn-back {
  position: absolute;
  margin-left: auto;
  margin-right: auto;
  left: 0;
  right: 0;
}

.btn-next {
  position: absolute;
  margin-left: auto;
  margin-right: auto;
  left: 0;
  right: 0;
}

.finished .icone {
  width: 200px;
  height: 200px;
  background-image: none;
}
.finished h3 {
  margin: 0;
}

.icone.not-animated {
  opacity: 1;
}

@keyframes dash-stroke-1 {
  0% {
    stroke-dasharray: 0, 500;
  }
  5% {
    opacity: 1;
  }
  100% {
    stroke-dasharray: 500, 500;
    opacity: 1;
  }
}
.finished .icone .path-1 {
  stroke-dasharray: 0;
  stroke-dashoffset: 0;
  opacity: 0;
  animation: dash-stroke-1 4s ease-out forwards 0.75s;
}
@keyframes dash-stroke-2 {
  0% {
    stroke-dasharray: 0, 500;
  }
  5% {
    opacity: 1;
  }
  100% {
    stroke-dasharray: 500, 500;
    opacity: 1;
  }
}
.finished .icone .path-2 {
  stroke-dasharray: 0;
  stroke-dashoffset: 0;
  opacity: 0;
  animation: dash-stroke-2 3s ease-out forwards 1s;
}

.icone-sucesso {
  margin: 40px 0;
}

.adquirente select {
  padding: 0 0 0 15px;
}

select {
  width: 100%;
  outline: none;
  padding: 0 10px 0 10px;
  border: solid 2px #e2e2e2;
  background-image: url("/assets/img/arrow-down.png");
  background-size: 30px;
  background-repeat: no-repeat;
  background-position-x: calc(100% - 10px);
  background-position-y: 6px;
}

.ui-select {
  width: 100%;
}

/* This is to remove the arrow of select element in IE */
select::-ms-expand {
  display: none;
}

select {
  appearance: none;
}

@-moz-document url-prefix() {
  .ui-select {
    border: 1px solid #CCC;
    border-radius: 4px;
    box-sizing: border-box;
    position: relative;
    overflow: hidden;
  }
  .ui-select select {
    width: 110%;
    background-position: right 30px center !important;
    border: none !important;
  }
}
.dropdown-toggle,
.dropdown-menu {
  width: 300px;
}

.btn-group img {
  float: left;
  margin-top: 0px;
  height: 15px;
}

.btn-group span {
  float: right;
  margin-right: 0px;
  height: 15px;
}

.dropdown-toggle {
  padding-right: 50px;
}

.dropdown-toggle .glyphicon {
  margin-left: 20px;
  margin-right: -40px;
}

.dropdown-header {
  background: #ccc;
  font-size: 14px;
  font-weight: 700;
  padding-top: 5px;
  padding-bottom: 5px;
  margin-top: 10px;
  margin-bottom: 5px;
}

.adquirente img {
  position: absolute;
  top: 31px;
  left: 50%;
  transform: translatex(-59%);
  width: 62px;
}

.btn-outline,
.btn-outline:active {
  color: #6a5cff;
  background: #f7f7f7;
  font-weight: bolder;
  box-shadow: inset 0px 0px 0px 2px #6a5cff !important;
}

.grupo-1,
.grupo-2,
.grupo-3 {
  opacity: 0;
  transition: all 0.5s ease;
}

.secao-ativa-4 {
  background: #f7f7f7;
  opacity: 0;
  height: 0;
}

.secao-ativa-4 svg {
  opacity: 0;
}

.secao-ativa-1 .grupo-1,
.secao-ativa-2 .grupo-2,
.secao-ativa-3 .grupo-3 {
  animation: animacao-direita-esquerda 0.75 forwards 0.5s;
  transform: translateX(-500px);
  transition: all 0.5s ease;
}

.fade-in-left {
  animation: fade-in-left 0.75s;
  transition: all 0.75 ease;
}

.fade-out-left {
  animation: fade-out-left 0.75s;
  transition: all 0.75 ease;
}

.fade-in-right {
  transform: translateX(500px);
  animation: fade-in-right 0.75s;
  transition: all 0.75 ease;
}

.fade-out-right {
  animation: fade-out-right 0.75s;
  transition: all 0.75 ease;
}

@keyframes animacao-direita-esquerda {
  0% {
    opacity: 0;
    transform: translateX(100px);
  }
  100% {
    opacity: 1;
    transform: translateX(-4px);
  }
}
@keyframes fade-out-left {
  0% {
    opacity: 1;
    transform: translateX(0);
  }
  100% {
    opacity: 0;
    transform: translateX(-500px);
  }
}
@keyframes fade-in-left {
  0% {
    opacity: 0;
    transform: translateX(-500px);
  }
  100% {
    opacity: 1;
    transform: translateX(0);
  }
}
@keyframes fade-out-right {
  0% {
    opacity: 1;
    transform: translateX(0);
  }
  100% {
    opacity: 0;
    transform: translateX(500px);
  }
}
@keyframes fade-in-right {
  0% {
    opacity: 0;
    transform: translateX(500px);
  }
  100% {
    opacity: 1;
    transform: translateX(0);
  }
}
.help-block {
  margin: 0 !important;
  position: absolute;
  left: 0;
  bottom: 0;
  transform: translateY(100%);
  font-size: 10px;
  font-weight: bold;
}

.relative {
  position: relative;
}`, "",{"version":3,"sources":["webpack://./src/app/modules/setup/setup.component.scss","webpack://./src/sass/_variables.scss"],"names":[],"mappings":"AACA;;;;EAII,8CAAA;EACA,yDAAA;EAAA,iDAAA;EACA,wCAAA;AAAJ;;AAGA;EACI,gBAAA;AAAJ;;AAII;EACI,qBAAA;EACA,UAAA;EACA,WAAA;EACA,mBAAA;EACA,yBCDI;EDEJ,aAAA;EACA,eAAA;AADR;AAEQ;EACI,yBChBD;ADgBX;;AAKA;EACI,gDAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;EACA,qBAAA;EACA,mBAAA;EACA,cClBQ;ADgBZ;AAGI;EAGI,2BAAA;EACA,0BAAA;AAHR;;AAOA;EACI,gBAAA;AAJJ;;AAOA;EACI,kBAAA;AAJJ;;AAOA;EACI,kBAAA;EACA,WAAA;EACA,aAAA;AAJJ;;AAOA;EACI,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,OAAA;EACA,QAAA;AAJJ;;AAOA;EACI,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,OAAA;EACA,QAAA;AAJJ;;AAQI;EACI,YAAA;EACA,aAAA;EACA,sBAAA;AALR;AAOI;EACI,SAAA;AALR;;AASA;EACI,UAAA;AANJ;;AAWQ;EACI;IACI,wBAAA;EARd;EAUU;IACI,UAAA;EARd;EAUU;IACI,0BAAA;IACA,UAAA;EARd;AACF;AAUQ;EACI,mBAAA;EACA,oBAAA;EACA,UAAA;EACA,mDAAA;AARZ;AAUQ;EACI;IACI,wBAAA;EARd;EAUU;IACI,UAAA;EARd;EAUU;IACI,0BAAA;IACA,UAAA;EARd;AACF;AAUQ;EACI,mBAAA;EACA,oBAAA;EACA,UAAA;EACA,gDAAA;AARZ;;AAaA;EACI,cAAA;AAVJ;;AAaA;EACI,mBAAA;AAVJ;;AAaA;EACI,WAAA;EACA,aAAA;EACA,sBAAA;EACA,yBAAA;EACA,mDAAA;EACA,qBAAA;EACA,4BAAA;EACA,wCAAA;EACA,0BAAA;AAVJ;;AAaA;EACI,WAAA;AAVJ;;AAaA,wDAAA;AAEA;EACI,aAAA;AAXJ;;AAcA;EAEI,gBAAA;AAXJ;;AAcA;EACI;IACI,sBAAA;IACA,kBAAA;IACA,sBAAA;IACA,kBAAA;IACA,gBAAA;EAXN;EAaE;IACI,WAAA;IACA,iDAAA;IACA,uBAAA;EAXN;AACF;AAcA;;EAEI,YAAA;AAZJ;;AAeA;EACI,WAAA;EACA,eAAA;EACA,YAAA;AAZJ;;AAeA;EACI,YAAA;EACA,iBAAA;EACA,YAAA;AAZJ;;AAeA;EACI,mBAAA;AAZJ;;AAeA;EACI,iBAAA;EACA,mBAAA;AAZJ;;AAeA;EACI,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,kBAAA;AAZJ;;AAeA;EACI,kBAAA;EACA,SAAA;EACA,SAAA;EACA,2BAAA;EACA,WAAA;AAZJ;;AAeA;;EAEI,cCzNM;ED0NN,mBC5MgB;ED6MhB,mBAAA;EACA,oDAAA;AAZJ;;AAeA;;;EAGI,UAAA;EACA,yBAAA;AAZJ;;AAeA;EACI,mBCzNgB;ED0NhB,UAAA;EACA,SAAA;AAZJ;;AAeA;EACI,UAAA;AAZJ;;AAeA;;;EAGI,uDAAA;EACA,6BAAA;EACA,yBAAA;AAZJ;;AAeA;EACI,6BAAA;EACA,yBAAA;AAZJ;;AAeA;EACI,8BAAA;EACA,yBAAA;AAZJ;;AAeA;EACI,4BAAA;EACA,8BAAA;EACA,yBAAA;AAZJ;;AAeA;EACI,+BAAA;EACA,yBAAA;AAZJ;;AAeA;EACI;IACI,UAAA;IACA,4BAAA;EAZN;EAcE;IACI,UAAA;IACA,2BAAA;EAZN;AACF;AAeA;EACI;IACI,UAAA;IACA,wBAAA;EAbN;EAeE;IACI,UAAA;IACA,6BAAA;EAbN;AACF;AAgBA;EACI;IACI,UAAA;IACA,6BAAA;EAdN;EAgBE;IACI,UAAA;IACA,wBAAA;EAdN;AACF;AAiBA;EACI;IACI,UAAA;IACA,wBAAA;EAfN;EAiBE;IACI,UAAA;IACA,4BAAA;EAfN;AACF;AAkBA;EACI;IACI,UAAA;IACA,4BAAA;EAhBN;EAkBE;IACI,UAAA;IACA,wBAAA;EAhBN;AACF;AAmBA;EACI,oBAAA;EACA,kBAAA;EACA,OAAA;EACA,SAAA;EACA,2BAAA;EACA,eAAA;EACA,iBAAA;AAjBJ;;AAoBA;EACI,kBAAA;AAjBJ","sourcesContent":["@import '../../../sass/variables';\ninput:-webkit-autofill,\ninput:-webkit-autofill:hover,\ninput:-webkit-autofill:focus,\ninput:-webkit-autofill:active {\n    -webkit-box-shadow: 0 0 0px 1000px white inset;\n    transition: background-color 5000s ease-in-out 0s;\n    -webkit-text-fill-color: #555 !important;\n}\n\n.btn-enviar {\n    margin-top: 20px;\n}\n\n.navegacao {\n    .ponto {\n        display: inline-block;\n        width: 6px;\n        height: 6px;\n        border-radius: 100%;\n        background-color: $cinza-400;\n        margin: 0 5px;\n        cursor: pointer;\n        &.ativo {\n            background-color: $azul-400;\n        }\n    }\n}\n\n.btn-invertido {\n    font-family: \"Pague.la\", \"Open Sans\", sans-serif;\n    font-size: 1.8rem;\n    padding: 10px 30px;\n    border-radius: 5px;\n    letter-spacing: 0.8px;\n    font-weight: bolder;\n    color: $cinza-500;\n    &:active,\n    &:hover,\n    &:focus {\n        box-shadow: none !important;\n        text-decoration: underline;\n    }\n}\n\n.secoes {\n    overflow: hidden;\n}\n\n.secao {\n    position: relative;\n}\n\n.btns {\n    position: relative;\n    width: 100%;\n    height: 100px;\n}\n\n.btn-back {\n    position: absolute;\n    margin-left: auto;\n    margin-right: auto;\n    left: 0;\n    right: 0;\n}\n\n.btn-next {\n    position: absolute;\n    margin-left: auto;\n    margin-right: auto;\n    left: 0;\n    right: 0;\n}\n\n.finished {\n    .icone {\n        width: 200px;\n        height: 200px;\n        background-image: none;\n    }\n    h3 {\n        margin: 0;\n    }\n}\n\n.icone.not-animated {\n    opacity: 1;\n}\n\n.finished {\n    .icone {\n        @keyframes dash-stroke-1 {\n            0% {\n                stroke-dasharray: 0, 500;\n            }\n            5% {\n                opacity: 1;\n            }\n            100% {\n                stroke-dasharray: 500, 500;\n                opacity: 1;\n            }\n        }\n        .path-1 {\n            stroke-dasharray: 0;\n            stroke-dashoffset: 0;\n            opacity: 0;\n            animation: dash-stroke-1 4s ease-out forwards 0.75s;\n        }\n        @keyframes dash-stroke-2 {\n            0% {\n                stroke-dasharray: 0, 500;\n            }\n            5% {\n                opacity: 1;\n            }\n            100% {\n                stroke-dasharray: 500, 500;\n                opacity: 1;\n            }\n        }\n        .path-2 {\n            stroke-dasharray: 0;\n            stroke-dashoffset: 0;\n            opacity: 0;\n            animation: dash-stroke-2 3s ease-out forwards 1.0s;\n        }\n    }\n}\n\n.icone-sucesso {\n    margin: 40px 0;\n}\n\n.adquirente select {\n    padding: 0 0 0 15px;\n}\n\nselect {\n    width: 100%;\n    outline: none;\n    padding: 0 10px 0 10px;\n    border: solid 2px $cinza-300;\n    background-image: url(\"/assets/img/arrow-down.png\");\n    background-size: 30px;\n    background-repeat: no-repeat;\n    background-position-x: calc(100% - 10px);\n    background-position-y: 6px;\n}\n\n.ui-select {\n    width: 100%\n}\n\n/* This is to remove the arrow of select element in IE */\n\nselect::-ms-expand {\n    display: none;\n}\n\nselect {\n    -webkit-appearance: none;\n    appearance: none;\n}\n\n@-moz-document url-prefix() {\n    .ui-select {\n        border: 1px solid #CCC;\n        border-radius: 4px;\n        box-sizing: border-box;\n        position: relative;\n        overflow: hidden;\n    }\n    .ui-select select {\n        width: 110%;\n        background-position: right 30px center !important;\n        border: none !important;\n    }\n}\n\n.dropdown-toggle,\n.dropdown-menu {\n    width: 300px\n}\n\n.btn-group img {\n    float: left;\n    margin-top: 0px;\n    height: 15px;\n}\n\n.btn-group span {\n    float: right;\n    margin-right: 0px;\n    height: 15px;\n}\n\n.dropdown-toggle {\n    padding-right: 50px\n}\n\n.dropdown-toggle .glyphicon {\n    margin-left: 20px;\n    margin-right: -40px\n}\n\n.dropdown-header {\n    background: #ccc;\n    font-size: 14px;\n    font-weight: 700;\n    padding-top: 5px;\n    padding-bottom: 5px;\n    margin-top: 10px;\n    margin-bottom: 5px\n}\n\n.adquirente img {\n    position: absolute;\n    top: 31px;\n    left: 50%;\n    transform: translatex(-59%);\n    width: 62px;\n}\n\n.btn-outline,\n.btn-outline:active {\n    color: $violeta;\n    background: $background-common;\n    font-weight: bolder;\n    box-shadow: inset 0px 0px 0px 2px #6a5cff !important;\n}\n\n.grupo-1,\n.grupo-2,\n.grupo-3 {\n    opacity: 0;\n    transition: all 0.5s ease;\n}\n\n.secao-ativa-4 {\n    background: $background-common;\n    opacity: 0;\n    height: 0;\n}\n\n.secao-ativa-4 svg {\n    opacity: 0;\n}\n\n.secao-ativa-1 .grupo-1,\n.secao-ativa-2 .grupo-2,\n.secao-ativa-3 .grupo-3 {\n    animation: animacao-direita-esquerda 0.75 forwards 0.5s;\n    transform: translateX(-500px);\n    transition: all 0.5s ease;\n}\n\n.fade-in-left {\n    animation: fade-in-left 0.75s;\n    transition: all 0.75 ease;\n}\n\n.fade-out-left {\n    animation: fade-out-left 0.75s;\n    transition: all 0.75 ease;\n}\n\n.fade-in-right {\n    transform: translateX(500px);\n    animation: fade-in-right 0.75s;\n    transition: all 0.75 ease;\n}\n\n.fade-out-right {\n    animation: fade-out-right 0.75s;\n    transition: all 0.75 ease;\n}\n\n@keyframes animacao-direita-esquerda {\n    0% {\n        opacity: 0;\n        transform: translateX(100px);\n    }\n    100% {\n        opacity: 1;\n        transform: translateX(-4px);\n    }\n}\n\n@keyframes fade-out-left {\n    0% {\n        opacity: 1;\n        transform: translateX(0);\n    }\n    100% {\n        opacity: 0;\n        transform: translateX(-500px);\n    }\n}\n\n@keyframes fade-in-left {\n    0% {\n        opacity: 0;\n        transform: translateX(-500px);\n    }\n    100% {\n        opacity: 1;\n        transform: translateX(0);\n    }\n}\n\n@keyframes fade-out-right {\n    0% {\n        opacity: 1;\n        transform: translateX(0);\n    }\n    100% {\n        opacity: 0;\n        transform: translateX(500px);\n    }\n}\n\n@keyframes fade-in-right {\n    0% {\n        opacity: 0;\n        transform: translateX(500px);\n    }\n    100% {\n        opacity: 1;\n        transform: translateX(0);\n    }\n}\n\n.help-block {\n    margin: 0!important;\n    position: absolute;\n    left: 0;\n    bottom: 0;\n    transform: translateY(100%);\n    font-size: 10px;\n    font-weight: bold;\n}\n\n.relative {\n    position: relative;\n}","// -------\n// Paleta de Cores\n// -------\n\n// Cores da Identidade - Listadas com base no gradiente principal\n\n$azul-200: #00f6ff;\n$azul-300: #00caff;\n$azul-400: #22b7ff;\n$azul-500: #4379ff;\n$violeta: #6a5cff;\n$roxo-500: #8e42ff;\n$roxo-400: #a42cff;\n$roxo-300: #a900ff;\n\n// Tons neutros \n\n$cinza-600: #777777;     //textos \"on\" - textos principais\n$cinza-500: #999999;     //textos \"off\" - textos auxiliares\n$cinza-400: #cccccc;      \n$cinza-300: #e2e2e2;     //bordas - menos vivo que o texto off\n$cinza-200: #e6e6e6;     //Para bullet points, e etc.\n$cinza-100: #ececec;     //tom mais claro de cinza após o background\n\n$background-common: #f7f7f7;\n$white: #fff;\n\n// Cores padrões\n\n$primary: $violeta;\n$secondary: $cinza-200;\n$success: $azul-500;\n$info: $azul-400;\n$warning: #edaf80;\n$danger: #e57373;\n$inverse: $cinza-500;\n\n\n//fontes - variáveis\n\n$fonte-pague-la: \"Pague.la\", \"Open Sans\", sans-serif;\n$fonte-open-sans: \"Open Sans\", sans-serif;\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
